import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";

import { useForm, useFieldArray } from "react-hook-form";
import { handleKeyPress } from "../../common/Events";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  VENDOR_APPOINTMENT_STEP_1,
  VENDOR_APPOINTMENT,
} from "../../utils/Validation";
import { useNotificationContext } from "../../common/NotificationContext";
import { useLoading } from "../../common/LoadingContext";
import { useLocation } from "react-router-dom";

import {
  Button,
  Grid,
  Box,
  Divider,
  FormLabel,
  Typography,
  MenuItem,
} from "@mui/material";
import { Add, Delete } from "@material-ui/icons";
import {
  padPONotAlpha,
  deriveIndex,
  getPODeliveryDate,
  setError1,
  setError2,
  setError3,
  setError4,
  setError5,
  getPOOnly,
  getASNOnly,
  compareDeliveryDateAndCurrentDate,
  checkOrderAPIResponseIsSuccess,
  checkOrderAPIResponseIsError,
  getPOEarliestDeliveryDate,
} from "../../utils/jsUtils";
import useGlobalState from "../../Context";
import { validateData } from "../../services/apiService";
import { appointmentConstant } from "../../utils/appointmentConstant";
import { APPOINTMENT_COFNIG_HEADER } from "../../utils/headerConstants";
import { getConfigService } from "../../services/apiService";
import DeliveryDateComponent from "./DeliveryDate";
import ItemTable from "./ItemTable";

const Step1 = ({
  onClickNext,
  formData,
  setFormData,
  materialTypeList,
  inputTypeList,
  setFirstTimeCheck,
  showCase,
  setShowCase,
  next,
  setNext,
  nextEnable,
  setNextEnable,
  strategy,
  setStrategy,
  showFilter,
  setShowFilter,
  dialogOpen,
  setDialogOpen,
  articles,
  setArticles,
  selectedArticles,
  setSelectedArticles,
  isSelectCheckBox,
  setIsSelectCheckBox,
  selectedRows,
  setSelectedRows,
  setConfig,
  setNoOfVehicle,
  setAppointmentStore,
  setDeliveryBookingWindow,
  diffDaysArray,
  setDiffDaysArray,
  deliveryDateArray,
  setDeliveryDateArray,
  setSubFormatCode,
  subFormatCode,
  setSiteConfig,
  setListOfPO,
  deliveryDateArray1,
  setDeliveryDateArray1,
  poComponentsCount,
  setPoComponentsCount,
}) => {
  const location = useLocation();
  const [{ userDetails }] = useGlobalState();

  const userParam = userDetails?.userParam;

  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const formOption = {
    defaultValues: {
      ...formData,
    },
    resolver: yupResolver(VENDOR_APPOINTMENT_STEP_1),
  };
  const {
    register,
    control,
    setValue,
    handleSubmit,
    formState,
    setError,
    clearErrors,
  } = useForm(formOption);
  const { errors } = formState;
  // const [poComponentsCount, setPoComponentsCount] = useState(
  //   formData?.poCount ?? 0
  // );
  const { fields, append, remove } = useFieldArray({
    name: "poDetails",
    control,
  });

  useEffect(() => {
    let { poDetails, appointmentId, asn, appointmentArticles } = formData;

    if (formData) {
      setValue("poDetails", poDetails);
      setValue("poCount", poDetails?.length);
      setPoComponentsCount(poDetails?.length);
      setSelectedArticles(appointmentArticles);
      setSelectedRows(appointmentArticles);

      setValue("appointmentId", appointmentId);
      setValue("asn", asn);
    }
  }, [formData, location, setValue]);

  function setDeliveryData(poDeliveryDate, currentDate) {
    const oneDay = 24 * 60 * 60 * 1000;
    const diffDays = Math.ceil((poDeliveryDate - currentDate) / oneDay);
    setDiffDaysArray((prevArray) => [...prevArray, diffDays]);
    setDeliveryDateArray((prevArray) => [...prevArray, poDeliveryDate]);
  }

  function earliestDeliveryBookingWindowValue(poList) {
    poList.forEach((po) => {
      var currentDate = new Date();
      let poDeliveryDate = getPOEarliestDeliveryDate(po);
      setDeliveryData1(poDeliveryDate, currentDate);
    });
  }

  function setDeliveryData1(poDeliveryDate, currentDate) {
    const oneDay = 24 * 60 * 60 * 1000;
    const diffDays = Math.ceil((poDeliveryDate - currentDate) / oneDay);
    setDeliveryDateArray1((prevArray) => [...prevArray, poDeliveryDate]);
  }

  const validateResponse = async (list, poDetails) => {
    let validateCheck = true;
    clearErrors();
    var currentDate = new Date();
    list.forEach((poList, idx) => {
      if (poList.physicalSiteCode) {
        if (checkOrderAPIResponseIsSuccess(poList)) {
          let resultIndex = deriveIndex(poDetails, poList);
          let poDeliveryDate = getPODeliveryDate(poList);
          //setDeliveryData(poDeliveryDate, currentDate);
          if (compareDeliveryDateAndCurrentDate(poDeliveryDate, currentDate)) {
            setError3(setError, resultIndex, poList);
            validateCheck = false;
          } else if (checkOrderAPIResponseIsError(poList)) {
            setError4(setError, resultIndex, poList);
            validateCheck = false;
          }
        } else {
          let resultIndex = deriveIndex(poDetails, poList);
          let poDeliveryDate = getPODeliveryDate(poList);
          //setDeliveryData(poDeliveryDate, currentDate);
          if (compareDeliveryDateAndCurrentDate(poDeliveryDate, currentDate)) {
            setError1(setError, resultIndex, poList);
            validateCheck = false;
          } else if (checkOrderAPIResponseIsError(poList)) {
            setError2(setError, resultIndex, poList);
            validateCheck = false;
          }
        }
      } else {
        setError5(setError, idx, poList);
        validateCheck = false;
      }
    });
    console.log(diffDaysArray);
    return validateCheck;
  };

  function lowestDeliveryBookingWindowValue(poList) {
    poList.forEach((po) => {
      var currentDate = new Date();
      let poDeliveryDate = getPODeliveryDate(po);
      setDeliveryData(poDeliveryDate, currentDate);
    });
  }

  async function getAppointmentStrategyAPICall(orderParams, setStrategy) {
    const param = {
      siteCode:
        orderParams?.formatCode === "M25"
          ? orderParams?.logicalSiteCode
          : orderParams?.physicalSiteCode,
      vendorCode: orderParams?.vendorCode,
    };
    const requestBody = {
      params: [param],
    };
    const configResponse = await getConfigService(
      requestBody,
      APPOINTMENT_COFNIG_HEADER
    );

    const vCode = configResponse?.param?.[0]?.vendorCode;
    const enableVendorDeliveryDateCheck =
      configResponse?.param?.[0]?.configs?.enableVendorDeliveryDateCheck;

    setStrategy(configResponse?.param?.[0]?.configs?.appointmentUnloadStrategy);
    setConfig(configResponse?.param?.[0]?.configs);
    setNoOfVehicle(configResponse?.param?.[0]?.configs?.maximumVehicleCount);

    if (vCode && enableVendorDeliveryDateCheck === false) {
      getAppointmentStrategyAPICall1(orderParams);
    }
    return configResponse;
  }

  async function getAppointmentStrategyAPICall1(orderParams) {
    const param = {
      siteCode:
        orderParams?.formatCode === "M25"
          ? orderParams?.logicalSiteCode
          : orderParams?.physicalSiteCode,
    };
    const requestBody = {
      params: [param],
    };
    const configResponse = await getConfigService(
      requestBody,
      APPOINTMENT_COFNIG_HEADER
    );
    setSiteConfig(configResponse?.param?.[0]);
  }

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      setDeliveryBookingWindow(0);
      setDiffDaysArray([]);
      setDeliveryDateArray([]);
      // Prepare order details
      const { poDetails } = data;
      const poList = getPOOnly(poDetails);
      const asnList = getASNOnly(poDetails);

      // Validate order data
      const response = await validateOrderData(poList, asnList);

      if (response?.messageCode === 6) {
        const orders = removeDuplicates(response);
        let validateCheck = await validateResponse(
          // response?.orderParams,
          orders?.orderParams,
          poDetails
        );

        if (validateCheck) {
          setListOfPO(response?.orderParams);
          lowestDeliveryBookingWindowValue(response?.orderParams);
          earliestDeliveryBookingWindowValue(response?.orderParams);
          const sortedArray = [...diffDaysArray].sort((a, b) => a - b);
          setDeliveryBookingWindow(sortedArray[0]);

          // Order details are valid
          showSuccessNotification();
          const orderParams = response?.orderParams?.[0];
          if (next) {
            // Fetch appointment config and strategy
            const configResponse = await getAppointmentStrategyAPICall(
              orderParams,
              setStrategy
            );
            if (configResponse?.messageCode === 6) {
              // Vendor is blocked for site
              if (configResponse?.param?.[0]?.configs?.blockAppointment) {
                showNotification(
                  "Error",
                  "You have been blocked on this Site Code (" +
                    configResponse?.param?.[0]?.siteCode +
                    ") for taking new appointments. Connect with Site / Warehouse Manager"
                );
              } else {
                moveToNextStep(
                  orderParams,
                  configResponse?.param?.[0]?.configs
                    ?.appointmentUnloadStrategy,
                  poDetails,
                  selectedArticles
                );
              }
            } else {
              if (configResponse?.param?.length === 0) {
                console.error(
                  "Site config empty | 1 | Error | Site | " +
                    orderParams?.physicalSiteCode
                );
              }
              showConfigNotification(
                orderParams?.formatCode === "M25"
                  ? orderParams?.logicalSiteCode
                  : orderParams?.physicalSiteCode
              );
            }
          } else {
            // Fetch appointment config and strategy
            const configResponse = await getAppointmentStrategyAPICall(
              orderParams,
              setStrategy
            );

            if (configResponse?.messageCode === 6) {
              if (configResponse?.param?.[0]?.configs?.blockAppointment) {
                showNotification(
                  "Error",
                  "You have been blocked for this Site Code (" +
                    configResponse?.param?.[0]?.siteCode +
                    ") for taking new appointments"
                );
              } else {
                if (
                  configResponse?.param?.[0]?.configs
                    ?.appointmentUnloadStrategy ===
                  appointmentConstant.ARTICLE_WISE_BOX_COUNT
                ) {
                  const articlesData = getArticlesData(response, poDetails);
                  setArticles(articlesData);
                  setDialogOpen(true);
                  setNext(true);
                } else {
                  setShowCase(true);
                  setNextEnable(true);
                  setNext(true);
                }
              }
            } else {
              if (configResponse?.param?.length === 0) {
                console.error(
                  "Site config empty | 1 | Error | Site | " +
                    orderParams?.physicalSiteCode
                );
              }
              showConfigNotification(
                orderParams?.formatCode === "M25"
                  ? orderParams?.logicalSiteCode
                  : orderParams?.physicalSiteCode
              );
            }
          }
        }
      } else if (
        response?.messageCode === 1 &&
        !!response?.orderParams &&
        response?.orderParams?.length > 0
      ) {
        validateResponse(response?.orderParams, poDetails);
        lowestDeliveryBookingWindowValue(response?.orderParams);
        earliestDeliveryBookingWindowValue(response?.orderParams);
        const sortedArray = [...diffDaysArray].sort((a, b) => a - b);
        setDeliveryBookingWindow(sortedArray[0]);
      } else {
        showNotification(
          "Error",
          response?.message ?? "Failed to verify data",
          "error"
        );
      }
    } catch (err) {
      showNotification(
        "Error",
        err?.message ?? "Failed to verify data",
        "error"
      );
    } finally {
      setLoading(false);
    }

    async function validateOrderData(poList, asnList) {
      const requestParam = {
        poList: poList,
        asnList: asnList,
        vendorCodes: [padPONotAlpha(userParam?.vendorCode)],
        vendorCode: padPONotAlpha(userParam?.vendorCode),
      };
      const requestBody = {
        params: [requestParam],
      };
      const response = await validateData(baseUrl, requestBody);

      setSubFormatCode(response?.orderParams?.[0]?.subFormatCode);
      return response;
    }

    function showSuccessNotification() {
      showNotification("Success", "Data validated successfully", "success");
    }

    function showConfigNotification(site) {
      showNotification(
        "Warning",
        site + " site is under maintainence",
        "warning"
      );
    }

    async function moveToNextStep(
      orderParams,
      strategyRes,
      poDetails,
      selectedArticles
    ) {
      onClickNext();
      setLoading(false);

      setFormData({
        ...formData,
        ...data,
        fcCode:
          orderParams?.formatCode === "M25"
            ? orderParams?.logicalSiteCode
            : orderParams?.physicalSiteCode,
        parentSiteCode: orderParams?.logicalSiteCode,
        fcName:
          orderParams?.formatCode === "M25"
            ? orderParams?.logicalSiteName
            : orderParams?.physicalSiteName,
        appointmentDate: "",
        startTime: "",
        strategy: strategy,
        selectedArticles: formData?.selectedArticles || selectedArticles,
      });
      setAppointmentStore([]);

      if (strategyRes === appointmentConstant.ARTICLE_WISE_BOX_COUNT) {
        poDetails.forEach((row) => {
          const matchingItems = (
            formData?.selectedArticles || selectedArticles
          )?.filter((item) => Number(item.poNumber) === Number(row.poNumber));

          // Initialize variables
          let noOfCases = 0;
          let countOfSkus = matchingItems.length;

          // Iterate over matchingItems to calculate noOfCases
          noOfCases = matchingItems.reduce(
            (sum, item) => sum + parseInt(item.articleBoxQuantity),
            0
          );

          // Update the updatedArray with the calculated values
          row.noOfCases = noOfCases.toString();
          row.countOfSkus = countOfSkus.toString();
          row.materialTypeId = "0";
        });
      }
    }
  };

  // function getArticlesData(response) {
  //   return response?.orderParams?.reduce((acc, item) => {
  //     item.articles.forEach((article) => {
  //       acc.push({
  //         poNumber: Number(item.poNumber),
  //         articleCode: article.articleCode,
  //         articleName: article.articleName,
  //         articleBoxQuantity: article.articleQuantity,
  //         articleQuantity: article.articleQuantity,
  //         eanNumber: article.eanNumbers[0],
  //         familyCode: article.familyCode,
  //         familyName: article.familyName,
  //       });
  //     });
  //     return acc;
  //   }, []);
  // }

  function getArticlesData(response, poDetails) {
    return response?.orderParams?.reduce((acc, item) => {
      const matchedPoDetail = poDetails.find(
        (po) => po.poNumber === item.poNumber || item.asnNumber
      );

      if (!matchedPoDetail) {
        console.warn(
          `No matching poDetails found for poNumber: ${item.poNumber}`
        );
        return acc; // Skip if no match is found
      }

      // Check the inputTypeId from the matched poDetail
      const inputTypeId = matchedPoDetail.inputTypeId;
      item.articles.forEach((article) => {
        acc.push({
          poNumber:
            inputTypeId === 1
              ? Number(item?.poNumber)
              : Number(item?.asnNumber),
          // poNumber: Number(item.poNumber),
          articleCode: article.articleCode,
          articleName: article.articleName,
          articleBoxQuantity: article.articleQuantity,
          articleQuantity: article.articleQuantity,
          eanNumber: article.eanNumbers[0],
          familyCode: article.familyCode,
          familyName: article.familyName,
        });
      });
      console.log(acc, acc);
      return acc;
    }, []);
  }

  function removeDuplicates(jsonResponse) {
    const uniqueOrderParams = [];
    const seenPoNumbers = new Set();

    // Iterate over orderParams
    jsonResponse?.orderParams?.forEach((order) => {
      let orderKey = "";
      if (order.poNumber && order.asnNumber) {
        orderKey = `${order.poNumber}-${order.asnNumber}`;
      } else if (order.poNumber) {
        orderKey = `${order.poNumber}`;
      } else if (order.asnNumber) {
        orderKey = `${order.asnNumber}`;
      }
      if (!seenPoNumbers.has(orderKey)) {
        seenPoNumbers.add(orderKey);
        uniqueOrderParams.push(order);
      }
    });
    // Update jsonResponse with unique orderParams
    jsonResponse.orderParams = uniqueOrderParams;

    // Remove duplicates from articles within each orderParam
    jsonResponse?.orderParams?.forEach((order) => {
      const uniqueArticles = [];
      const seenArticleCodes = new Set();

      order?.articles?.forEach((article) => {
        if (!seenArticleCodes.has(article?.articleCode)) {
          seenArticleCodes.add(article.articleCode);
          uniqueArticles.push(article);
        }
      });

      order.articles = uniqueArticles;
    });

    return jsonResponse;
  }

  useEffect(() => {
    setValue("poCount", poComponentsCount);
    const newVal = parseInt(poComponentsCount || 0);
    const oldVal = fields.length;
    if (newVal > oldVal) {
      for (let i = oldVal; i < newVal; i++) {
        append({
          poNumber: "",
          noOfCases: "",
          countOfSkus: "",
          materialTypeId: "",
        });
      }
    }
  }, [append, fields.length, poComponentsCount, setValue]);

  useEffect(() => {
    if (selectedArticles?.length > 0) {
      setNextEnable(true);
    }
  }, [formData, selectedArticles?.length, setNextEnable]);

  useEffect(() => {
    if (formData.poDetails?.length) {
      setPoComponentsCount(formData.poDetails.length);
    }
  }, [formData.poDetails]);

  return (
    <>
      <Grid className="bg-white">
        <Grid item xs={12} md={12}>
          <form onSubmit={handleSubmit(onSubmit)}>
            {fields.map((val, index) => {
              return (
                <Grid item xs={12} md={12} sx={{ px: 4, py: 1 }} key={index}>
                  <Box
                    sx={{
                      my: 1,
                      p: 1.5,
                      borderRadius: 2,
                      borderColor: poComponentsCount > 1 ? "#4d6fa552" : "none",
                      borderStyle: poComponentsCount > 1 ? "solid" : "none",
                      borderWidth: poComponentsCount > 1 ? "2px" : "none",
                    }}
                  >
                    <Grid
                      container
                      direction="row"
                      justifyContent="flex-start" // Align items horizontally at the start
                      alignItems="flex-start"
                      display="flex"
                      flexDirection={"row"}
                      spacing={1}
                    >
                      <Grid
                        item
                        xs={12}
                        sm={0.4}
                        mb={2}
                        display="flex"
                        justifyContent="center"
                        alignContent="center"
                        flexDirection={"column"}
                      >
                        {poComponentsCount > 1 && (
                          <Box
                            py={0.5}
                            px={1.5}
                            mt={4.8}
                            sx={{ backgroundColor: "#e7e7e7", borderRadius: 2 }}
                          >
                            <Typography variant="h6">{index + 1}</Typography>
                          </Box>
                        )}
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={showCase ? 11 / 5 : 5.5}
                        mb={2}
                        display="flex"
                        justifyContent="center"
                        alignContent="center"
                        flexDirection={"column"}
                      >
                        <FormLabel
                          required={true}
                          className="stepperFormLabel"
                          sx={{
                            width: "150px",
                            marginTop: "10px",
                            marginBottom: "10px",
                          }}
                        >
                          Order Type{" "}
                        </FormLabel>
                        <TextField
                          name={`poDetails[${index}]inputTypeId`}
                          defaultValue={val?.inputTypeId}
                          className="stepperFormInput2"
                          select
                          fullWidth
                          style={{ textAlign: "start" }}
                          size="small"
                          autoComplete="off"
                          placeholder="Select PO / ASN"
                          {...register(`poDetails.${index}.inputTypeId`)}
                          error={
                            !!errors?.poDetails?.[index]?.inputTypeId
                              ? Boolean(
                                  `${errors?.poDetails?.[index]?.inputTypeId}`
                                )
                              : false
                          }
                          helperText={
                            !!errors?.poDetails?.[index]?.inputTypeId
                              ? `${errors?.poDetails?.[index]?.inputTypeId?.message}`
                              : ""
                          }
                        >
                          {inputTypeList.length > 0 &&
                            inputTypeList.map((option) => (
                              <MenuItem
                                key={option.inputTypeId}
                                value={option.inputTypeId}
                              >
                                {option.inputTypeName}
                              </MenuItem>
                            ))}
                        </TextField>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={showCase ? 11 / 5 : 5.5}
                        mb={2}
                        display="flex"
                        justifyContent="center"
                        alignContent="center"
                        flexDirection={"column"}
                      >
                        <FormLabel
                          required={true}
                          className="stepperFormLabel"
                          sx={{
                            width: "150px",
                            marginTop: "10px",
                            marginBottom: "10px",
                          }}
                        >
                          PO
                        </FormLabel>
                        <TextField
                          defaultValue={val.poNumber}
                          className="stepperFormInput2"
                          name={`poDetails[${index}]poNumber`}
                          type="text"
                          fullWidth
                          size="small"
                          autoComplete="off"
                          onKeyDown={handleKeyPress}
                          {...register(`poDetails[${index}].poNumber`, {
                            required: "true",
                          })}
                          error={
                            !!errors?.poDetails?.[index]?.poNumber
                              ? Boolean(
                                  `${errors?.poDetails?.[index]?.poNumber}`
                                )
                              : false
                          }
                          helperText={
                            !!errors?.poDetails?.[index]?.poNumber?.message
                              ? `${errors?.poDetails?.[index]?.poNumber?.message}`
                              : ""
                          }
                        />
                        <DeliveryDateComponent
                          deliveryDateArray={deliveryDateArray}
                          index={index}
                          deliveryDateArray1={deliveryDateArray1}
                        />
                      </Grid>
                      {showCase && (
                        <>
                          <Grid
                            item
                            xs={12}
                            sm={11 / 5}
                            mb={2}
                            display="flex"
                            justifyContent="center"
                            alignContent="center"
                            flexDirection={"column"}
                          >
                            <FormLabel
                              required={true}
                              className="stepperFormLabel"
                              sx={{
                                width: "150px",
                                marginTop: "10px",
                                marginBottom: "10px",
                              }}
                            >
                              No Of Cases
                            </FormLabel>
                            <TextField
                              defaultValue={val?.noOfCases}
                              className="stepperFormInput2"
                              name={`poDetails[${index}]noOfCases`}
                              type="number"
                              fullWidth
                              size="small"
                              autoComplete="off"
                              {...register(`poDetails.${index}.noOfCases`)}
                              onChange={() => {
                                setFirstTimeCheck(true);
                              }}
                              error={
                                !!errors?.poDetails?.[index]?.noOfCases
                                  ? Boolean(
                                      `${errors?.poDetails?.[index]?.noOfCases}`
                                    )
                                  : false
                              }
                              helperText={
                                !!errors?.poDetails?.[index]?.noOfCases?.message
                                  ? `${errors?.poDetails?.[index]?.noOfCases?.message}`
                                  : ""
                              }
                            />
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={11 / 5}
                            mb={2}
                            display="flex"
                            justifyContent="center"
                            alignContent="center"
                            flexDirection={"column"}
                          >
                            <FormLabel
                              required={true}
                              className="stepperFormLabel"
                              sx={{
                                width: "150px",
                                marginTop: "10px",
                                marginBottom: "10px",
                              }}
                            >
                              Count of SKUs{" "}
                            </FormLabel>
                            <TextField
                              defaultValue={val?.countOfSkus}
                              className="stepperFormInput2"
                              name={
                                (`poDetails[${index}]countOfSkus`,
                                { required: true })
                              }
                              type="text"
                              fullWidth
                              size="small"
                              autoComplete="off"
                              {...register(`poDetails.${index}.countOfSkus`)}
                              error={
                                !!errors?.poDetails?.[index]?.countOfSkus
                                  ? Boolean(
                                      `${errors?.poDetails?.[index]?.countOfSkus}`
                                    )
                                  : false
                              }
                              helperText={
                                !!errors?.poDetails?.[index]?.countOfSkus
                                  ? `${errors?.poDetails?.[index]?.countOfSkus?.message}`
                                  : ""
                              }
                            />
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={11 / 5}
                            mb={2}
                            display="flex"
                            justifyContent="center"
                            alignContent="center"
                            flexDirection={"column"}
                          >
                            <FormLabel
                              required={true}
                              className="stepperFormLabel"
                              sx={{
                                width: "150px",
                                marginTop: "10px",
                                marginBottom: "10px",
                              }}
                            >
                              Material Type{" "}
                            </FormLabel>
                            <TextField
                              name={
                                (`poDetails[${index}]materialTypeId`,
                                { required: true })
                              }
                              defaultValue={val?.materialTypeId}
                              className="stepperFormInput2"
                              select
                              fullWidth
                              style={{ textAlign: "start" }}
                              size="small"
                              autoComplete="off"
                              {...register(
                                `poDetails[${index}].materialTypeId`
                              )}
                              error={
                                !!errors?.poDetails?.[index]?.materialTypeId
                                  ? Boolean(
                                      `${errors?.poDetails?.[index]?.materialTypeId}`
                                    )
                                  : false
                              }
                              helperText={
                                !!errors?.poDetails?.[index]?.materialTypeId
                                  ? `${errors?.poDetails?.[index]?.materialTypeId?.message}`
                                  : ""
                              }
                            >
                              {materialTypeList.length > 0 &&
                                materialTypeList
                                  .filter(
                                    (option) =>
                                      String(option.subFormatCode) ===
                                      String(subFormatCode)
                                  )
                                  .map((option) => (
                                    <MenuItem
                                      key={option.materialTypeId}
                                      value={option.materialTypeId}
                                    >
                                      {option.materialType}
                                    </MenuItem>
                                  ))}
                            </TextField>
                          </Grid>
                        </>
                      )}
                      {poComponentsCount > 1 && (
                        <Grid
                          item
                          xs={12}
                          sm={0.6}
                          mb={2}
                          display="flex"
                          justifyContent="center"
                          alignContent="center"
                          flexDirection={"column"}
                        >
                          <Box mt={4.8}>
                            <Button
                              variant="text"
                              size="small"
                              color="error"
                              onClick={() => {
                                remove(index);
                                setPoComponentsCount(
                                  (prevValue) => prevValue - 1
                                );
                                if (next === true) {
                                  setNext(false);
                                }
                              }}
                            >
                              <Delete />
                            </Button>
                          </Box>
                        </Grid>
                      )}
                    </Grid>
                  </Box>
                </Grid>
              );
            })}
            <React.Fragment>
              {strategy === "articleWiseCount" && <Divider />}
              {dialogOpen && (
                <Box
                  sx={{
                    my: 1,
                    px: 2,
                  }}
                >
                  <ItemTable
                    articles={articles}
                    setArticles={setArticles}
                    selectedArticles={selectedArticles}
                    setSelectedArticles={setSelectedArticles}
                    showFilter={showFilter}
                    setShowFilter={setShowFilter}
                    isSelectCheckBox={isSelectCheckBox}
                    setIsSelectCheckBox={setIsSelectCheckBox}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    // orderType={orderType}
                  ></ItemTable>
                </Box>
              )}
            </React.Fragment>
            <br></br>

            <React.Fragment>
              <Divider />
              <Box sx={{ display: "flex", flexDirection: "row", p: 2 }}>
                {next && (
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setNext(false);
                    }}
                    sx={{ mr: 1 }}
                  >
                    Back
                  </Button>
                )}
                <Box sx={{ flex: "1 1 auto" }} />
                {poComponentsCount < 100 && (
                  <Button
                    startIcon={<Add />}
                    sx={{ float: "right", mr: 6 }}
                    onClick={() => {
                      setPoComponentsCount((prevValue) => prevValue + 1);
                      if (next === true) {
                        setNext(false);
                      }
                    }}
                    variant="contained"
                  >
                    Add More
                  </Button>
                )}

                {!next && (
                  <Button
                    type="submit"
                    onClick={() => {}}
                    sx={{ mr: 1 }}
                    variant="outlined"
                  >
                    Verify
                  </Button>
                )}
                {next && nextEnable && (
                  <>
                    <Button
                      type="submit"
                      onClick={() => {}}
                      sx={{ mr: 1 }}
                      variant="outlined"
                    >
                      Next
                    </Button>
                  </>
                )}
              </Box>
            </React.Fragment>
          </form>
        </Grid>
      </Grid>
    </>
  );
};
export default Step1;
